import { Menu, MenuButton, MenuItem } from 'reakit/Menu';
import { Button } from 'reakit/Button';
import { Toolbar } from 'reakit/Toolbar';
import styled from 'styled-components';

export const StyledToolbar = styled(Toolbar)`
  width: 100%;
  && > *:not(:first-child) {
    font-size: 14px;
    margin: 0;
  }
`;

export const StyledLogo = styled.button`
  margin: 16px 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const StyledHeader = styled.div`
  display: flex;
  max-height: 64px;
  width: 100%;
`;

export const VerticalSeparator = styled.hr`
  height: 64px;
  border: 0;
  border-left: 1px solid;
  border-color: #dedede;
  margin: 0;
  padding: 0;
  width: 1px;
`;

export const StyledMenuButton = styled(MenuButton)`
  && {
    border-radius: 0;
    font-size: 14px;
    padding: 0 24px;
  }

  &&&:active {
    background-color: #f5f5f5;
    outline: none;
  }

  &&&:focus {
    color: #303030;
    outline: 0;
  }

  &&&:hover,
  &&:not([aria-disabled='true'])[aria-expanded='true'],
  &&[aria-expanded='true'] {
    background-color: #fff;
    border-color: #fff;
    color: #303030;
  }

  && svg {
    fill: #303030;
    height: 0.5em;
    width: 0.5em;
  }
`;

export const StyledToolbarItemButton = styled(Button)`
  && {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    margin: 0 8px;
    padding: 0 24px;
  }

  &&&:not([aria-selected='true']) {
    background-color: #f5f5f5;
  }

  &&&:active {
    background-color: #f5f5f5;
    outline: none;
  }

  &&&:focus {
    color: #303030;
    outline: 0;
  }

  &&&:hover,
  &&[aria-expanded='true'] {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    color: #303030;
  }
`;

export const StyledDraftButton = styled.button`
  && {
    cursor: default;
    border: none;
    background-color: RGB(254, 242, 235);
    color: RGB(235, 100, 53);
  }
`;

export const StyledPreviewButton = styled.button`
  && {
    cursor: default;
    border: none;
    background-color: RGBA(0, 69, 165, 0.08);
    color: RGBA(0, 69, 165, 1);
  }
`;

export const StyledOptionsWrapper = styled.div`
  display: flex;
  padding: 16px 24px;
`;

export const StyledPreviewWrapper = styled(StyledOptionsWrapper)`
  margin-left: auto !important;
`;

export const StyledOptionsLabel = styled.div`
  line-height: 32px;
  margin-right: 8px;
`;

export const MoreItemsWrapper = styled.div`
  display: flex;
  position: relative;
`;

export const StyledMenu = styled(Menu)`
  && {
    border: 0;
    border-radius: 0 0 4px 4px;
    box-shadow: 0px 10px 20px 3px rgba(0, 0, 0, 0.3) !important;
    position: relative;
    right: 0 !important;
    min-width: max-content;
    width: 100%;
  }

  &&[aria-orientation='vertical'] {
    padding: 5px 0;
  }

  &&::before {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid #fff;
    content: '';
    height: 0px;
    left: 50%;
    position: absolute;
    top: -8px;
    width: 0px;
    transform: translateX(-50%);
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &&&& {
    font-size: 14px;
    font-weight: 400;
    padding: 19px 12px;
  }

  &&&[aria-expanded='true'],
  &&&&:hover,
  &&&&:focus {
    background-color: #f5f5f5;
    color: #303030;
    cursor: pointer;
  }
`;

export const StyledMenuItemText = styled.span`
  vertical-align: top;
  display: inline-block;
  line-height: 20px;
  white-space: nowrap;
`;

export const StyledMenuItemIcon = styled.span`
  vertical-align: middle;
  display: inline-block;
  margin-right: 8px;
`;
